// oxlint-disable max-lines-per-function
import { FieldBase } from '@/components/form';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import {
  Feiertagsausgleich,
  feiertagsausgleich,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/feiertagsausgleichRegelung';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerTrigger,
  ScrollArea,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui';
import { faAngleDown, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function FeiertagsausgleichSelect() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <form.AppField name="abwesenheiten.feiertagseinstellungen.feiertagsausgleich">
        {(field) => (
          <FieldBase
            label={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.label',
            )}>
            <Select
              value={field.state.value ?? ''}
              onValueChange={(e) =>
                field.handleChange(e as Feiertagsausgleich)
              }>
              <SelectTrigger className="md:flex hidden">
                <SelectValue
                  onBlur={field.handleBlur}
                  placeholder={t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.placeholder',
                  )}
                />
              </SelectTrigger>
              <SelectContent>
                {Object.keys(feiertagsausgleich).map((key) => (
                  <SelectItem key={key} value={key}>
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.options.' +
                        key,
                    )}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
              <DrawerTrigger className="md:hidden flex" asChild>
                <Button
                  variant={'outline-secondary'}
                  className="md:hidden flex flex-row justify-between gap-1 w-full text-neutrals-900 text-sm font-normal max-w-96 border-neutrals-200 hover:bg-neutrals-100"
                  role="combobox"

                  type="button">
                  {field.state.value &&
                    t(
                      `domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.options.${field.state.value}`,
                    )}
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className="h-4 w-4 ml-auto"
                  />
                </Button>
              </DrawerTrigger>
              <DrawerContent className="flex flex-col gap-4 p-4">
                <div className="font-semibold text-center">
                  {t(
                    `domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.label`,
                  )}
                </div>

                <ScrollArea className="overflow-auto max-h-108">
                  <div className="flex flex-col gap-2">
                    {Object.keys(feiertagsausgleich).map((key) => (
                      <div
                        className="flex justify-between items-center gap-2 not-last:border-b border-neutrals-200 pb-2"
                        key={key}
                        onClick={() => {
                          field.handleChange(key as Feiertagsausgleich);
                          setIsDrawerOpen(false);
                        }}>
                        <span>
                          {t(
                            `domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.feiertagsausgleich.options.${key}`,
                          )}
                        </span>
                        {field.state.value === key && (
                          <FontAwesomeIcon
                            className="text-primary-blue-600 pr-2"
                            icon={faCheck}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </ScrollArea>
              </DrawerContent>
            </Drawer>
          </FieldBase>
        )}
      </form.AppField>
    </>
  );
}
